import React, { useEffect, useState } from 'react'
import {useTranslation} from 'react-i18next'; 
import styled from 'styled-components';
import Text from '../../genericComponents/Text';
import { RowTypeSpaceBetween } from '../../genericComponents/Layouts';
import logo from '../../../assets/images/logo.png';
import logo2 from '../../../assets/images/logo2.png';
import { jsPDF } from "jspdf";
import MyHeatMap from './MyHeatMap';
import MyBarChart from './MyBarChart';
import * as htmlToImage from 'html-to-image';
import { getQueryVariable } from '../../../helpers/queryhandler';
const urlImage = 'https://media.equipson.es/img/WEB/';

export default function PrintArea({pdfName,printing,setPrinting,showAmplifier,simulationData,amplifier,speaker}){
  const { t } = useTranslation();
  const langSelected = localStorage.getItem("i18nextLng") || "en";
  const [project] = useState(getQueryVariable('project'));

  useEffect(() => { if(printing) print(); }, [printing])

  async function print() {
    try {
      const doc = new jsPDF('p', 'mm', 'a4');
      
      let currentTop=10;
      const header = document.getElementById('printid1');
      const canvasHeader = await htmlToImage.toCanvas(header,{quality:0.5})
      const heightHeader = ( canvasHeader.height* 190 / canvasHeader.width);
      doc.addImage(canvasHeader, 'PNG', 10, 10, 190, heightHeader);
      currentTop+=heightHeader+2;
      
      for (let index = 2; index <= 9; index++) {
        if(index===8&&(!showAmplifier||!amplifier.name))continue;
        const div = document.getElementById('printid'+index);
        let canvas = await htmlToImage.toCanvas(div,{quality:0.5});
        const height= ( canvas.height* 190 / canvas.width);
        if((currentTop+height)>=260){
          doc.addPage()
          doc.addImage(canvasHeader, 'PNG', 10, 10, 190, heightHeader);
          currentTop=heightHeader+12;
        }
        doc.addImage(canvas, 'PNG', 10, currentTop, 190, height);
        currentTop+=height+4;
        // console.log('currentTop: printid',index,currentTop)
        
      }
      doc.save(pdfName+'.pdf');
  
      setPrinting(false);
    } catch (error) {
      console.error(error)
      setPrinting(false);
    }
  }

  const speakerslogan = (langSelected==='es'?simulationData?.speaker?.slogan_100:simulationData?.speaker?.slogan_101)?.split('. ');
  const amplifierSlogan = (langSelected==='es'?showAmplifier?.amplifier?.slogan_100:showAmplifier?.amplifier?.slogan_101)?.split('. ');
  if(amplifierSlogan?.length){
    const last =amplifierSlogan.length-1
    amplifierSlogan[last]=amplifierSlogan[last].endsWith('.')?amplifierSlogan[last].substring(0,amplifierSlogan[last].length-1):null;
  }
  if(speakerslogan?.length){
    const last =speakerslogan.length-1
    speakerslogan[last]=speakerslogan[last].endsWith('.')?speakerslogan[last].substring(0,speakerslogan[last].length-1):null;
  }
  
  return (
    <>
      {simulationData&&(

      <div style={{width:960,paddingRight:8}}>
        <div id="printid1" style={{paddingRight:8}}>
          <div style={{display:'flex',justifyContent:'space-between'}}>
            <div style={{paddingTop:16}}>
              <Text titleSize={3} titleLevel={1} strong style={{lineHeight:0.7}}>{t('project')}: {pdfName}</Text>
              <Text titleSize={2} titleLevel={4}>{t('acoustic_simulator_results')}</Text>
            </div>
            <Logo src={project==='workpro'?logo2:logo} height={50} />
          </div>
        </div>
        <div id="printid2" style={{paddingRight:8}}>
          <SquareBox>
            <EqualCont style={{width:130,paddingLeft:0}}>
              <Text titleSize={2} titleLevel={4} strong>{t('room')}</Text>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',flex:1}}>
                <div style={{display:'flex',flexDirection:'column',felx:1,justifyContent: 'space-between'}}>
                  <Text>{t('length')}</Text>
                  <Text titleLevel={4} strong>{simulationData?.width} m</Text>
                </div>
                <div style={{display:'flex',flexDirection:'column',felx:1,justifyContent: 'space-between'}}>
                  <Text>{t('width')}</Text>
                  <Text titleLevel={4} strong>{simulationData?.heigth} m</Text>
                </div>
                <div style={{display:'flex',flexDirection:'column',felx:1,justifyContent: 'space-between'}}>
                  <Text>{t('height')}</Text>
                  <Text titleLevel={4} strong>{simulationData?.long} m</Text>
                </div>
              </div>
            </EqualCont>
            <EqualCont style={{width:320,borderLeft: '1px solid #CCC'}}>
              <Text titleSize={2} titleLevel={4} strong>{t('speaker_select')}</Text>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',flex:1}}>
                <div style={{width:110,display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <Text style={{width:110}}>{t('kind_of_power')}</Text>
                  <Text titleLevel={4} strong>
                    {simulationData?.typePower==='lowImpedance'?t('lowImpedance'):simulationData?.typePower}
                  </Text>
                </div>
                <div style={{width:110,display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <Text style={{width:110}}>{t('speaker_selected')}</Text>
                  <Text titleLevel={4} strong>{simulationData?.speaker?.speakerName}</Text>
                </div>
                <div style={{width:55,display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <Text>{t('power')}</Text>
                  <Text titleLevel={4} strong>{simulationData?.power} W</Text>
                </div>
              </div>
            </EqualCont>
            <EqualCont style={{width:460,paddingRight:0,borderLeft: '1px solid #CCC'}}>
              <Text titleSize={2} titleLevel={4} strong>{t('simulation_parameters_min')}</Text>
              <div style={{display:'flex',flex:1,flexDirection:'row',justifyContent:'space-between'}}>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <Text>{t('simulation_type')}</Text>
                  <Text titleLevel={4} strong >
                    {simulationData.simulationType===1?
                      t('edge_to_edge'):
                      simulationData.simulationType===2?
                        t('minimum_overlap'):t('center_to_center')
                    }
                  </Text>
                </div>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <Text>{t('frequency_range')}</Text>
                  <Text titleLevel={4} strong style={{minWidth:138}}>{
                    simulationData.frecuencyRange==='polars2500Hz'?
                      t('public_address_2500Hz'):
                      simulationData.frecuencyRange==='polars5000Hz'?
                        t('voice_5000Hz'):t('music_10000Hz')
                    }
                  </Text>
                </div>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <Text>{t('background_noise')}</Text>
                  <Text titleLevel={4} strong>{simulationData.newnoiseLevel} dB</Text>
                </div>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                  <Text>{t('ear_height')}</Text>
                  <Text titleLevel={4} strong>{simulationData.newearHeight} m</Text>
                </div>
              </div>
            </EqualCont>
          </SquareBox>
        </div>
        <div id="printid3" style={{paddingRight:8}}>
          <SquareBox >
            <div  style={{flex:1,display: 'flex',flexDirection: 'row',justifyContent: 'space-between'}}>
              <div style={{minWidth:'30%'}}>
                <Text titleSize={2} titleLevel={4} strong style={{lineHeight:0.9}}>{t('speaker')}</Text>
                <Text titleSize={2} titleLevel={4} style={{lineHeight:1.2}}>{`${t('model')}: ${simulationData?.speaker?.speakerName}`}
                </Text>
                <Text titleSize={2} titleLevel={3}>
                  {speakerslogan&&speakerslogan[0]}
                </Text>
                <div style={{marginBottom:6}}/>
                <Text titleLevel={4} strong>{t('characteristics')}</Text>
                {speakerslogan.slice(1).map((f,i)=>
                  <Text style={{marginLeft:16}} key={i} titleLevel={4}>• {f}</Text>
                )}
              </div>
              <div>
                <img 
                  alt=""
                  width={200}
                  src={urlImage+simulationData?.speaker?.media?.find(m=>m.mediaOrder==="0").path}
                />
              </div>
                <img 
                  alt=""
                  height={45}
                  style={{maxHeight:50}}
                  src={simulationData?.speaker?.brandlogo} 
                />
            </div>  
          </SquareBox>
        </div>
        <div id="printid4" style={{paddingRight:8}}>
          <SquareBox style={{flexDirection:'column',alignItems:'flex-start'}}>
            <Text titleSize={2} titleLevel={4} strong style={{width:'100%'}}>{t('sound_preasure_distribution')}</Text>
            <br/>
            <MyHeatMap printing lengthPoints={8} simulationData={simulationData} t={t}/>
            <Text titleLevel={4}>(*) {t('simulation_results_note')}</Text>
          </SquareBox>
          </div>
        <div id="printid5" style={{paddingRight:8}}>
          <SquareBox style={{flexDirection:'column',alignItems:'flex-start'}}>
            <Text titleSize={2} titleLevel={4} strong style={{width:'100%'}}>{t('speakers_position')}</Text>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
              <div style={{display:'flex',flex:1,flexDirection:'column',padding:'0 10px',justifyContent:'space-between'}}>
                <Text titleLevel={4} titleSize={1}>{t('first_last_column_distance')}</Text>
                <Text titleLevel={4} titleSize={1} strong>(A) {Number(simulationData.SPx[1]||0).toFixed(1)}m</Text>{/*TODO: add data*/}
              </div>
              <div style={{display:'flex',flex:1,flexDirection:'column',padding:'0 10px',justifyContent:'space-between'}}>
                <Text titleLevel={4} titleSize={1}>{t('first_last_row_distance')}</Text>
                <Text titleLevel={4} titleSize={1} strong>(B) {Number(simulationData.SPy[1]||0).toFixed(1)}m</Text>{/*TODO: add data*/}
              </div>
              {simulationData.SPx?.length>1&&(
                <div style={{display:'flex',flex:1,flexDirection:'column',padding:'0 10px',justifyContent:'space-between'}}>
                  <Text titleLevel={4} titleSize={1}>{t('distance_between_speakers_per_columns')}</Text>
                  <Text titleLevel={4} titleSize={1} strong>(C) {(Number(simulationData.SPx[2]||0)-Number(simulationData.SPx[1]||0)).toFixed(1)}m</Text>{/*TODO: add data*/}
                </div>
              )}
              {simulationData.SPy?.length>1&&(
                <div style={{display:'flex',flex:1,flexDirection:'column',padding:'0 10px',justifyContent:'space-between'}}>
                  <Text titleLevel={4} titleSize={1}>{t('distance_between_speakers_per_rows')}</Text>
                  <Text titleLevel={4} titleSize={1} strong>(D) {(Number(simulationData.SPy[2]||0)-Number(simulationData.SPy[1]||0)).toFixed(1)}m</Text>{/*TODO: add data*/}
                </div>
              )}
            </div>
          </SquareBox>
        </div>
        <div id="printid6" style={{paddingRight:8}}>
          <SquareBox style={{flexDirection:'column',alignItems:'flex-start'}}>
            <Text titleSize={2} titleLevel={4} strong style={{width:'100%'}}>{t('spl_distribution')}</Text>
            <MyBarChart simulationData={simulationData} t={t}/>
            <Text titleLevel={4}>(*) {t('simulation_results_note')}</Text>
          </SquareBox>
        </div>
        <div id="printid7" style={{paddingRight:8}}>
          <SquareBox style={{flexDirection:'column',alignItems:'flex-start'}}>
            <Text titleSize={2} titleLevel={4} strong>{t('recommendations')}</Text>
            <RowTypeSpaceBetween style={{width:'100%'}}>
              <div/>
              <div style={{display:'flex',flex:1,flexDirection:'column'}}>
                <Text titleLevel={4}>{t('total_number_of_speakers')}</Text>
                <Text titleSize={2} titleLevel={4} strong>{speaker?.quantity} {t('units')}</Text>
              </div>
              <div style={{display:'flex',flex:1,flexDirection:'column'}}>
                <Text titleLevel={4}>{t('total_power_consumed')}</Text>
                <Text titleSize={2} titleLevel={4} strong>{Number(speaker?.quantity)*Number(simulationData?.power)} W</Text>
              </div>
              <div style={{display:'flex',flex:1,flexDirection:'column'}}>
                <Text titleLevel={4}>{t('minimum_amplifier_power')}</Text>
                <Text titleSize={2} titleLevel={4} strong>
                  {parseFloat(Number(speaker?.quantity)*Number(simulationData?.power)*1.2).toFixed(2)} W
                </Text>
                <Text  titleLevel={4}>20% {t('over_total_power')}</Text>
              </div>
              <div/>
            </RowTypeSpaceBetween>
          </SquareBox>
        </div>
        {showAmplifier&&amplifier.name&&
          <div id="printid8" style={{paddingRight:8}}>
            <SquareBox >
              <div  style={{flex:1,display: 'flex',flexDirection: 'row',justifyContent: 'space-between'}}>
                <div style={{minWidth:'30%'}}>
                  <Text titleSize={2} titleLevel={4} strong style={{lineHeight:0.9}}>{t('amplifier')}</Text>
                  <Text titleSize={2} titleLevel={4} style={{lineHeight:1.2}}>{`${t('model')}: ${showAmplifier?.amplifier?.name}`}
                  </Text>
                  <Text titleSize={2} titleLevel={3}>
                    {amplifierSlogan&&amplifierSlogan[0]}
                  </Text>
                  <div style={{marginBottom:6}}/>
                  <Text titleLevel={4} strong>{t('characteristics')}</Text>
                  {amplifierSlogan.slice(1).map((r,i)=>
                    <Text style={{marginLeft:16}} key={i} titleLevel={4}>• {r}</Text>
                  )}
                </div>
                <div>
                  <img 
                    alt=""
                    width={200}
                    src={urlImage+showAmplifier?.amplifier?.media.find(m=>m.mediaOrder==="0").path}
                  />
                </div>
                <img 
                  alt=""
                  height={45}
                  style={{maxHeight:50}}
                  src={showAmplifier?.amplifier?.brandlogo} 
                />
              </div>  
            </SquareBox>
          </div>
        }
        <div id="printid9" style={{paddingRight:8}}>
          <SquareBox style={{flexDirection:'column',alignItems:'flex-start'}}>
            <Text titleSize={2} titleLevel={4} strong style={{width:'100%'}}>{t('equipment_list')}</Text>
            <RowTypeSpaceBetween style={{width:'100%'}}>
              <div/>
              <div style={{display:'flex',flex:5,flexDirection:'column'}}>
                <Text titleSize={1} titleLevel={4}>{t('total_number_of_speakers')}</Text>
                <Text titleSize={2} titleLevel={4} strong>{speaker?.quantity} {t('units')}</Text>
              </div>
              <div style={{display:'flex',flex:4,flexDirection:'column'}}>
                <Text titleSize={1} titleLevel={4}>{t('speaker_model')}</Text>
                <Text titleSize={2} titleLevel={4} strong>{simulationData?.speaker?.speakerName}</Text>
              </div>
              {showAmplifier&&amplifier.name&&
                <>
                  <Divider/>
                  <div style={{display:'flex',flex:6,flexDirection:'column'}}>
                    <Text titleSize={1} titleLevel={4}>{t('total_number_of_amplifiers')}</Text>
                    <Text titleSize={2} titleLevel={4} strong>{amplifier?.quantity}  {t('units')}</Text>
                  </div>
                  <div style={{display:'flex',flex:5,flexDirection:'column'}}>
                    <Text titleSize={1} titleLevel={4}>{t('amplifier_model')}</Text>
                    <Text titleSize={2} titleLevel={4} strong>{amplifier?.name}</Text>
                  </div>
                </>
              }
              <div/>
            </RowTypeSpaceBetween>
          </SquareBox>
        </div>
      </div>
      )}
    </>
  )
}

const Logo = styled.img`
  width: 100px;
  height: 30px;
`;
const SquareBox = styled.div`
  padding: 8px;
  border: solid 1px #CCC;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  /* align-items: flex-end; */
  margin-right: 16px;
  flex:1;
`;
const EqualCont = styled.div`
  display:flex;
  /* flex:1; */
  height: auto;
  flex-direction: column;
  padding: 0 6px;
`;
const Divider = styled.div`
  width: 1px;
  height: 60px;
  margin-right: 8px;
  background: #CCC;

`;